// src/components/ChatBot/index.js
import '../../css/chatbot.css';
import React, { useState, useEffect } from 'react';
import { ChatProvider, useChat } from './ChatContext';
import { MessageList } from './MessageComponents';
import MessageInputComponent from './MessageInputComponent';
import ChatHead from './ChatHead';
import StatsSidebar from './StatsSidebar';
import StreamTabs from './StreamTabs';

const ContextPanel = () => {
  const { contentInfo } = useChat();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1000);
    };

    // Check initial mobile state
    checkMobile();

    // Add event listener to check on resize
    window.addEventListener('resize', checkMobile);

    // Cleanup listener
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  // Render context content
  const renderContextContent = () => {
    if (!contentInfo || !contentInfo.passage) {
      return <div className="context-empty">No context available</div>;
    }

    return <div className="context-passage">{contentInfo.passage}</div>;
  };

  return (
    <div className={`context-panel ${isMobile ? 'mobile-context-panel' : ''}`}>
      <div className="context-header">
        <h2 className="context-title">Context</h2>
      </div>
      <div className={`context-content ${isMobile ? 'mobile-context-content' : ''}`}>
        {renderContextContent()}
      </div>
    </div>
  );
};

const ChatBot = () => {
  const { activeStream } = useChat(); // Get activeStream to conditionally render
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1000);
    };

    // Check initial mobile state
    checkMobile();

    // Add event listener to check on resize
    window.addEventListener('resize', checkMobile);

    // Cleanup listener
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

//   return (
//     <div className="chatbot-container">
//       <StatsSidebar />
//       <div className="chatbot-main-content">
//         <ChatHead />
        
//         <div className={`chatbot-main ${isMobile ? 'mobile-layout' : ''}`}>
//           {isMobile ? (
//             // Mobile layout - vertical stacking with fixed heights
//             <div className="mobile-chat-container">
//               <div className="mobile-context-section">
//                 <ContextPanel />
//               </div>
//               <div className="mobile-message-section">
//                 <div className="mobile-message-list-section">
//                   <MessageList />
//                 </div>
//                 <div className="mobile-message-input-section">
//                   <MessageInputComponent />
//                 </div>
//               </div>
//             </div>
//           ) : (
//             // Desktop layout - side by side (unchanged)
//             <>
//               <div className="context-section">
//                 <ContextPanel />
//               </div>
//               <div className="chat-section">
//                 <div className="message-list-section">
//                   <MessageList />
//                 </div>
//                 <div className="message-input-section">
//                   <MessageInputComponent />
//                 </div>
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

  return (
    <div className="chatbot-container">
      <StatsSidebar />
      <div className="chatbot-main-content">
        <ChatHead />
        <div className={`chatbot-main ${isMobile ? 'mobile-layout' : ''}`}>
          {isMobile ? (
            <div className="mobile-chat-container">
              <div className="mobile-context-section"> <ContextPanel /> </div>
              <div className="mobile-message-section">
                <StreamTabs /> {/* --- Add StreamTabs --- */}
                <div className="mobile-message-list-section"> <MessageList /> </div>
                <div className="mobile-message-input-section">
                  {/* For Stage 1, input only for chat. Tutor interaction will be just viewing the initial msg */}
                  <MessageInputComponent />
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="context-section"> <ContextPanel /> </div>
              <div className="chat-section">
                <StreamTabs /> {/* --- Add StreamTabs --- */}
                <div className="message-list-section"> <MessageList /> </div>
                <div className="message-input-section">
                  {/* For Stage 1, input only for chat. */}
                  <MessageInputComponent />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const ChatBotWithProvider = () => (
  <ChatProvider>
    <ChatBot />
  </ChatProvider>
);

export default ChatBotWithProvider;